import React, { useContext } from "react"

import MicrocopyContext from "~contexts/MicrocopyContext"
import Endpoint from "./Endpoint"
import { prioritize, sortBy, VERBS } from '../../../../utils/sort'

const Endpoints = ({ endpoints = [], hideHeaders, sortByKey = false }) => {
  const microcopy = useContext(MicrocopyContext)

  return (
    <>
      {endpoints?.[0] && !hideHeaders && (
        <header>{microcopy.text("search.filter_types.endpoints")}</header>
      )}
      {(sortByKey ? endpoints.sort(sortBy('key')) : endpoints).sort(prioritize).map((endpoint) => (
        <Endpoint
          key={endpoint.id}
          verb={VERBS[endpoint.verb]}
          endpoint={endpoint}
          microcopy={microcopy}
        />
      ))}
    </>
  )
}

export default Endpoints
